export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '4b251f0d9fmshc62295b8a5f0a99p16be5bjsn04ab17d09d5e',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const baseURL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const Weather_APT_URL = "https://api.openweathermap.org/data/2.5";

export const Weather_APT_Key = "9ed8e5609aec675e73bad9a2c876068d";